import React from 'react'
import { Link } from 'react-router-dom'
import { Row, Col, Input, Icon, Button, Collapse, Select, Spin, Modal, Tabs } from 'antd'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import { UrlMeeting } from '../../../../utils/auth'
import { changeFormatdateSlip } from '../../../../utils/formatdate'
import { downloadFile } from '../../../../utils/downloadFile'
import moment from 'moment/min/moment-with-locales';
import axios from 'axios';
import iconDeclineRed from '../../../../assets/images/icons/icon-decline-red.png'
import iconInfoYellow from '../../../../assets/images/icons/icon-info-yellow.png'
import iconSummitGreen from '../../../../assets/images/icons/icon-summit-green.png'
import iconSwap from '../../../../assets/images/icons/icon-swap.png'
import axiosAPI from '../../../../config/axiosAPI'

const { Option } = Select;
const { Search } = Input;
const { TextArea } = Input;
const { Panel } = Collapse;
const { TabPane } = Tabs;

class NoteMeetingForm extends React.Component {

    state = {
        idMeeting: null,
        dataMeeting: {
            Comments: [
                {
                    title: "",
                    firstName: "",
                    lastName: "",
                }
            ]
        },
        ApproverDetail: [],
        OrganizerDetail: [],
        GuestsInvite: [],
        OtherGuestsInvite: [],
        Summaries: [],
        preload: null,
        statusAccept: null,
        commentAccept: null,
        editCommentAccept: "",
        countInternal: 0,
        countExternal: 0,
        showEditcomment: false,
        countLike: 0,
        countComment: 0,
        loadingScreen: false,
        comments: [],
        isSummaryDueDateExpired: false,
        showModalInvitee: false,
    }

    componentDidMount = async () => {
        await this.fetchDataMeeting();
    }
    fetchDataMeeting = async () => {
        const queryString = require('query-string');
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.id) await this.setState({ idMeeting: parsed.id })
        // console.log("parsed.id", parsed.id);
        this.setState({ loadingScreen: true })
        await axiosAPI.post(`${UrlMeeting()}/meeting/secure/meetingdetail`,
            {
                MeetingID: parsed.id
            })
            .then(response => {
                const data = response.data.status.message
                this.setState({
                    dataMeeting: data[0] ? data[0] : [],
                    ApproverDetail: data[1].ApproverDetail ? data[1].ApproverDetail : [],
                    OrganizerDetail: data[1].OrganizerDetail ? data[1].OrganizerDetail : [],
                    GuestsInvite: data[0].Guests ? data[0].Guests : [],
                    OtherGuestsInvite: data[0].OtherGuests ? data[0].OtherGuests : [],
                    preload: false,
                    Summaries: data[0].Summaries && data[0].Summaries.length > 0 ? data[0].Summaries : [],
                    loadingScreen: false,
                    isSummaryDueDateExpired: data[0]?.isSummaryDueDateExpired ?? false
                })
                console.log("data", data);
                const found = (data[0].Comments).find(obj => {
                    return obj.userID === sessionStorage.getItem('username');
                });
                console.log("data[0].Comments", data[0].Comments);
                if (data[0].Comments && found.status == "Accept") {
                    this.setState({
                        statusAccept: found.status,
                    });
                }

                if (data[0].Comments && data[0].Comments.length > 0) {

                    const filterLike = data[0].Comments.filter(o => o.status == "Accept")
                    const countLike = [...new Set(filterLike.map((o) => o.userID))].length;

                    const filterComment = data[0].Comments.filter(o => o.changeDetail != null)
                    const countComment = [...new Set(filterComment.map((o) => o.userID))].length;
                    const sortComment = data[0].Comments.sort((a, b) => moment(b.createDate) - moment(a.createDate))

                    const findCommentAccept = filterComment.some(o => o.userID === sessionStorage.getItem('username'))

                    this.setState({
                        countLike,
                        countComment,
                        comments: sortComment,
                        commentAccept: findCommentAccept,
                    });
                }

                let countInternal = 0;
                let countExternal = 0;
                data[0].Guests.forEach(element => {
                    if (element.StatusResponse.statusName != "Waiting") {
                        countInternal = countExternal + 1;
                    }
                    this.setState({ countInternal });
                });
                data[0].OtherGuests.forEach(element => {
                    if (element.StatusResponse.statusName != "Waiting") {
                        countExternal = countExternal + 1;
                    }
                    this.setState({ countExternal });
                });
                if (!this.state.commentAccept) {
                    this.editComment();
                }
            }).catch(error => {
                this.setState({ loadingScreen: false, })
                console.error(`Error: ${error}`)
            })
    }

    getLength = (arr) => {
        if (arr) {
            return arr.length;
        }
    }

    onChange = ({ target: { value } }) => {
        this.setState({ editCommentAccept: value });
    };
    editComment = () => {
        this.setState({ editCommentAccept: "" });
    };

    acceptSummary = () => {
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/acceptsummarymeeting`,
            {
                MeetingID: this.state.idMeeting,
                UserID: sessionStorage.getItem('username'),
                Status: "Accept"
            })
            .then(response => {
                this.fetchDataMeeting();
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }
    saveEditComment = () => {
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/commentsummarymeeting`,
            {
                MeetingID: this.state.idMeeting,
                UserID: sessionStorage.getItem('username'),
                ChangeDetail: this.state.editCommentAccept
            })
            .then(response => {
                this.setState({ editCommentAccept: "" })
                this.fetchDataMeeting();
                this.editComment();
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    };

    iconFile = (type) => {
        if (["pdf", "PDF"].includes(type)) {
            return "file-pdf";
        } else if (["doc", "docx", "words"].includes(type)) {
            return "file-word";
        } else if (["xlsx", "excel"].includes(type)) {
            return "file-excel";
        } else if (["ppt", "pptx"].includes(type)) {
            return "file-ppt";
        } else if (["png", "jpg"].includes(type)) {
            return "file-image"
        } else if (["zip"].includes(type))
            return "file-zip"
        else {
            return "file";
        }
    }

    getLength = (arr) => {
        if (arr) {
            return arr.length;
        }
    }

    getLengthAcceptInternal = (data) => {
        return data.filter(o => o.StatusResponse.statusName.toLowerCase() == "join").length
    }

    getLengthAcceptExternal = (data) => {
        return data.filter(o => o.asRole == "1").length
    }

    onCloseModalInvitee = () => {
        this.setState({ showModalInvitee: false })
    }

    selectIconPath = (status) => {
      switch (status) {
          case 'Waiting':
              return iconInfoYellow
          case 'Join':
              return iconSummitGreen
          case 'Refuse':
              return iconDeclineRed
          case 'Agent':
              return iconSwap
          case '1':
              return iconInfoYellow
          case '2':
              return iconSummitGreen
      }
  }

    render() {
        const { match } = this.props
        const { dataMeeting, OrganizerDetail, ApproverDetail, OtherGuestsInvite, Summaries, GuestsInvite, showEditcomment, countLike, countComment, comments, isSummaryDueDateExpired } = this.state
        const dateTime = !(dataMeeting?.startDate && dataMeeting?.endDate) ? "" : `${changeFormatdateSlip(moment(dataMeeting.startDate))} / ${moment(dataMeeting.startDate).format('HH:ss')} - ${moment(dataMeeting.endDate).format('HH:ss')} น.`

        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalConfirmErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}

                <Spin tip="Loading..." size="large" spinning={this.state.loadingScreen} style={{ alignItems: 'center', position: 'initial' }}>
                    <div className="card-container meeting-management" id="form-meeting">
                        <div className="card-bg-white">
                            <Row className="pt-4 pb-3 px-3" gutter={16} type="flex">
                                <Col xs={19} >
                                    <Link
                                        to={{
                                            pathname: `/meetingmanagement/noteMeeting`,
                                        }}>
                                        <Icon type="left" className="icon-back-meeting" /><p style={{ display: "inline", color: "#4D4D4D" }}> รายละเอียดการขอความเห็นชอบ</p>
                                    </Link>
                                </Col>
                            </Row>
                            <Row gutter={16} type="flex">
                                <Col lg={{ span: 20, offset: 2 }} >
                                    <Row className="px-5 py-3 pb-5" gutter={16} type="flex" align="top">
                                        <Col xs={12}>
                                            <Icon type="user" className="icon-fonttext-meeting" />
                                            <p className="text-title-meeting ml-2 mb-0">ผู้เชิญประชุม</p><br />
                                            <p className="text-detail-meeting ml-2">{OrganizerDetail.title} {OrganizerDetail.firstName} {OrganizerDetail.lastName}</p>
                                        </Col>
                                        {ApproverDetail.length != 0 ?
                                            < Col xs={12}>
                                                <Icon type="user" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ผู้อนุมัติการประชุม</p><br />
                                                <p className="text-detail-meeting ml-2">{ApproverDetail.firstName} {ApproverDetail.lastName}</p>
                                            </Col>
                                            :
                                            <></>
                                        }
                                        <Col xs={24} className="pt-3">
                                            <Icon type="menu" className="icon-fonttext-meeting" />
                                            <p className="text-title-meeting ml-2 mb-0">หัวข้อการประชุม</p><br />
                                            <p className="text-detail-meeting ml-2">{dataMeeting.subject}</p>
                                        </Col>

                                        <Col xs={12} className="pt-3">
                                            <Icon type="clock-circle" className="icon-fonttext-meeting" />
                                            <p className="text-title-meeting ml-2 mb-0">กำหนดการ</p><br />
                                            <p className="text-detail-meeting ml-2">{moment(dataMeeting.startDate).locale('th').add(543, 'year').format('DD MMMM YYYY')} / {moment(dataMeeting.startDate).format('HH:mm')} - {moment(dataMeeting.endDate).format('HH:mm')} น.</p>
                                        </Col>
                                        <Col xs={12} className="pt-3">
                                            <Icon type="clock-circle" className="icon-fonttext-meeting" />
                                            <p className="text-title-meeting ml-2 mb-0" style={{ display: 'inline' }}>วันที่ออกเอกสาร</p><br />
                                            <p className="text-detail-meeting ml-2" style={{ display: 'inline' }}>{dataMeeting.documentDate ? moment(dataMeeting.documentDate).locale('th').add(543, 'year').format('DD MMMM YYYY') : "-"}</p>
                                        </Col>

                                        <Col xs={24} className="pt-3">
                                            <Icon type="environment" className="icon-fonttext-meeting" />
                                            <p className="text-title-meeting ml-2 mb-0">สถานที่จัดการประชุม</p><br />
                                            <p className="text-detail-meeting ml-2">{dataMeeting.location}</p>
                                        </Col>

                                        <Col xs={24} className="pt-3">
                                            <Icon type="team" className="icon-fonttext-meeting" />
                                            <p className="text-title-meeting ml-2 mb-0">รายชื่อผู้ถูกเชิญ ({GuestsInvite.length + OtherGuestsInvite.length})</p>
                                            <span onClick={() => this.setState({ showModalInvitee: true })} style={{ color: '#3C8BE9', cursor: 'pointer' }}>{"  ดูเพิ่มเติม"}</span>
                                            <br />
                                        </Col>

                                        <Col xs={12} className="pt-3">
                                            <p className="text-title-meeting ml-2 pl-3">ผู้เข้าร่วมภายใน ({this.getLengthAcceptInternal(GuestsInvite)}/{GuestsInvite.length})</p><br />

                                            {
                                                GuestsInvite.map((element, i) => {
                                                    if (i >= 5) {
                                                        return <></>
                                                    }
                                                    return (<p className="text-detail-meeting ml-2">{i + 1}. {element.title} {element.firstName} {element.lastName}<br /></p>)
                                                }
                                                )
                                            }
                                        </Col>
                                        <Col xs={12} className="pt-3">
                                            <p className="text-title-meeting ml-2 pl-3">ผู้เข้าร่วมภายนอก ({this.getLengthAcceptExternal(OtherGuestsInvite)}/{OtherGuestsInvite.length})</p><br />
                                            {
                                                OtherGuestsInvite.map((element, i) => {
                                                    if (i >= 5) {
                                                        return <></>
                                                    }
                                                    return (<p className="text-detail-meeting ml-2">{i + 1}. {element.name}<br /></p>)
                                                }
                                                )
                                            }
                                        </Col>

                                        <Col xs={24} className="pt-3">
                                            <Icon type="menu" className="icon-fonttext-meeting" />
                                            <p className="text-title-meeting ml-2 mb-0">รายละเอียด</p><br />
                                            <p className="text-detail-meeting ml-2">{dataMeeting.detail}</p>
                                        </Col>

                                        <Col xs={24} className="pt-3">
                                            <Icon type="video-camera" className="icon-fonttext-meeting" />
                                            <p className="text-title-meeting ml-2 mb-0">ลิงค์การประชุม</p><br />
                                            <a href={dataMeeting.meetingURL} target='_blank' className="ml-4">{dataMeeting.meetingURL}</a>
                                        </Col>

                                        <Col xs={24} className="pt-3">
                                            <Icon type="paper-clip" className="icon-fonttext-meeting" />
                                            <p className="text-title-meeting ml-2 mb-0">ไฟล์แนบ</p><br />
                                            {
                                                (
                                                    dataMeeting.Attacheds ? dataMeeting.Attacheds : []).map((file, i) =>
                                                        <Row>
                                                            <a className="ml-4" onClick={() => {
                                                                downloadFile(`${UrlMeeting()}/meeting/file/${file.fileNameGen}`, file.fileName)
                                                            }}>{file.fileName}</a>
                                                        </Row>
                                                    )
                                            }
                                        </Col>
                                        <div className="my-5">
                                            <Button disabled={true} className={'button-meeting-bg-red mt-3 mt-lg-0 mb-4'} style={{ padding: '20px !important', width: 'auto' }} >
                                                แนบไฟล์บันทึกหลังการประชุม
                                                <Icon type="form" />
                                            </Button>
                                            {Summaries && Summaries.length > 0 &&
                                                (Summaries.map((file, i) => {
                                                    return (
                                                        <div>
                                                            <p
                                                                style={{
                                                                    color: "gray",
                                                                    padding: "3px 16px",
                                                                    display: "inline-block",
                                                                    border: "1px solid gray",
                                                                    borderRadius: "20px",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                <Icon type={this.iconFile(file.fileType)} className="pr-3" />
                                                                {file.id ? (
                                                                    <a
                                                                        style={{ color: "gray" }}
                                                                        onClick={() => {
                                                                            downloadFile(`${UrlMeeting()}/meeting/file/${file.fileNameGen}`, file.fileName)
                                                                        }}
                                                                    >
                                                                        {file.fileName}

                                                                    </a>
                                                                ) : (
                                                                    <a style={{ color: "gray" }}>{file.fileName}</a>
                                                                )}
                                                            </p>
                                                        </div>
                                                    )
                                                }))
                                            }
                                        </div>
                                        <Col xs={24} style={{ display: 'flex' }}>
                                            <Button disabled={isSummaryDueDateExpired} onClick={this.acceptSummary} className={'mr-3'} style={{ color: (this.state.statusAccept == "Accept" ? "#178991" : "#FDB75D"), backgroundColor: "transparent" }}>
                                                <Icon type="like" />เห็นชอบ ({`${countLike}/${GuestsInvite.length + OtherGuestsInvite.length}`})</Button>
                                            <Button disabled={isSummaryDueDateExpired} className={''} style={{ color: (this.state.commentAccept ? "#178991" : "#808080"), backgroundColor: "transparent" }} >
                                                <Icon type="message" />แสดงความคิดเห็น ({`${countComment}/${GuestsInvite.length + OtherGuestsInvite.length}`})</Button>
                                        </Col>

                                        {!isSummaryDueDateExpired && (
                                            <Col xs={24}>
                                                <TextArea
                                                    className='mt-3'
                                                    value={this.state.editCommentAccept}
                                                    onChange={this.onChange}
                                                    rows={4}
                                                />
                                                <Col onClick={this.editComment} className='pt-3' span={4} offset={16} align="end">
                                                    <Button disabled={!this.state.editCommentAccept} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }} >
                                                        ยกเลิก</Button>
                                                </Col>
                                                <Col className='pt-3' span={4} align="end">
                                                    <Button disabled={!this.state.editCommentAccept} onClick={this.saveEditComment} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff" }}>
                                                        บันทึก</Button>
                                                </Col>
                                            </Col>
                                        )}
                                        {comments.map((comment) => {
                                            return (
                                                comment?.changeDetail ? (
                                                    <Col xs={24} className="mt-3">
                                                        <Row gutter={16} type="flex">
                                                            <Col xs={20} className="p-3" style={{ backgroundColor: "#EBF4F1", borderRadius: "10px", width: 'fit-content', maxWidth: '600px' }}>
                                                                <p className="text-name-message mb-2" style={{ color: "#178991" }}>{comment.title} {comment.firstName} {comment.lastName}</p>
                                                                <p className="text-note-message">{comment.changeDetail}</p>
                                                                <p style={{ color: '#999999' }} className="text-note-message mb-0">
                                                                    {moment(comment.createDate || '').add(543, 'year').locale('th').format('DD MMMM YYYY HH:mm น.')}
                                                                </p>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                ) : <></>
                                            )
                                        })}
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Modal
                        // maskClosable={false}
                        className={"meeting-invitee-modal"}
                        visible={this.state.showModalInvitee}
                        onCancel={this.onCloseModalInvitee}
                        closable={true}
                        title="รายชื่อผู้อนุมัติการประชุม "
                        footer={[
                            <Button
                                key="close"
                                className={"btn-modal-confirm"}
                                onClick={this.onCloseModalInvitee}
                            >
                                ปิด
                            </Button>
                        ]}
                    >
                        <div style={{ height: 400, width: 400, overflow: "auto", overflowX: "hidden" }}>
                            <Row gutter={16} className={"pt-0"}>
                                <Tabs defaultActiveKey="1" >
                                    <TabPane
                                        style={{ marginLeft: '2%' }}
                                        tab={`ผู้เข้าร่วมภายใน (${this.getLengthAcceptInternal(GuestsInvite)}/${this.getLength(GuestsInvite)})`} key="1">
                                        {GuestsInvite.map((element, i) => {
                                            return (
                                                <Row type='flex' align='middle' className='my-3'>
                                                    <Col xs={20}>
                                                        <span className="text-detail-meeting">{element.title} {element.firstName} {element.lastName}</span>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <img src={this.selectIconPath(element.StatusResponse.statusName)} style={{ maxWidth: '20px', height: 'auto' }} />
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    </TabPane>
                                    <TabPane
                                        tab={`ผู้เข้าร่วมภายนอก (${this.getLengthAcceptExternal(OtherGuestsInvite)}/${this.getLength(OtherGuestsInvite)})`} key="2">
                                        {OtherGuestsInvite.map((element, i) => {
                                            return (
                                                <Row type='flex' align='middle' className='my-3'>
                                                    <Col xs={20}>
                                                        <span className="text-detail-meeting">{element.name}</span>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <img src={this.selectIconPath(element.asRole)} style={{ maxWidth: '20px', height: 'auto' }} />
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    </TabPane>
                                </Tabs>
                            </Row>
                        </div>
                    </Modal>
                </Spin>
            </Container >
        )
    }
}

NoteMeetingForm.propTypes = {
    //
}

export default withApollo(NoteMeetingForm)